import _styled from "styled-components";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Skeleton } from "@crehana/ui";
import cn from "classnames";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { css } from "styled-components";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MentorCardSkeleton = function MentorCardSkeleton(_ref) {
  var isDark = _ref.isDark;
  return /*#__PURE__*/_jsxs(_StyledDiv, {
    className: cn('flex flex-col rounded-5 overflow-hidden p-16', isDark ? 'bg-base-light-dark-mode' : 'bg-white shadow-1-dp'),
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex items-center mb-24 flex-col",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        className: "w-full h-280 flex-shrink-0",
        isDark: isDark
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex items-center px-16 pt-16 justify-between w-full",
        children: [/*#__PURE__*/_jsx(Skeleton, {
          className: "h-16 w-1/2",
          isDark: isDark
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex items-center justify-between w-1/5",
          children: [/*#__PURE__*/_jsx(Skeleton, {
            className: "h-16 w-1/3",
            isDark: isDark
          }), /*#__PURE__*/_jsx(Skeleton, {
            className: "h-16 w-1/3",
            isDark: isDark
          })]
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "mb-24",
      children: /*#__PURE__*/_jsx("div", {
        className: "flex flex-wrap",
        children: Array.from({
          length: 4
        }).map(function (_, index) {
          return /*#__PURE__*/_jsx(Skeleton
          // biome-ignore lint/suspicious/noArrayIndexKey: index as key is acceptable here
          , {
            className: "h-24 w-1/4 rounded-2 mb-8 mr-8",
            isDark: isDark
          }, "mentor-card-skeleton-tags-".concat(index * 1));
        })
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "mt-auto justify-self-end",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        className: "h-40 w-full mb-12 rounded-5",
        isDark: isDark
      }), /*#__PURE__*/_jsx(Skeleton, {
        className: "h-40 w-full rounded-5",
        isDark: isDark
      })]
    })]
  });
};
export default MentorCardSkeleton;
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-1rsrdh5-0"
})(["\n        min-height: 454px;\n      "]);